module.exports = __webpack_public_path__ + "static/media/Brittany.ce30fea3.png";